import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMMDD');

export default {
	gridList: [],
	searchParams: SEARCH_PARAMS(),
	groups: GROUPS(),
	prvsClCdList: [],
	ckuPrvsCdList: [],
	ckuPrvsCdAllList: [],
	ynCdList: [],
	rsltCdList: [{label: 'OK', value: 'OK'}, {label: 'NG', value: 'NG'}]
};
function GROUPS() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
function SEARCH_PARAMS() {
	return {
		strDt: '',
		endDt: '',
		rollId: '',
		cellId: '',
		partNo: '',
		prvsClCd: '',
		ckuPrvsCd: '',
		rsltCd:''
	};
}

export { SEARCH_PARAMS, GROUPS };
